import * as getters from "../../baseQuestion/date/store/getters";
import * as mutations from "../../baseQuestion/date/store/mutations";
import * as actions from "../../baseQuestion/date/store/actions";
import { state as base_state } from "../../baseQuestion/date/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_high_school"
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
